import React from 'react';
import moment from 'moment-timezone';
import { Link } from '@ontruck/orc';

import tel from 'utils/phone';

const joinArrayStringBreakLine = (arrayStrings) => (arrayStrings || []).join('\n').split('\n');

const t = {
  pending_appointment: 'Pending appointment',
  appointment: 'appointment',
  requested_by_shipper: 'Time requested by shipper:',
  appointment_instructions: 'Appointment instructions:',
  internal_reference: 'Internal reference:',
  special_instructions: 'Special instructions for the driver:',
  contact: 'Contact person:',
  no_internal_reference: 'No internal reference',
};

const ShipperOrderTimes = ({ shipperOrder }) => {
  const { appointment_required: appointmentRequired, has_appointment_time: hasAppointmentTime } =
    shipperOrder || {};

  if (appointmentRequired && !hasAppointmentTime) {
    return <>{t.pending_appointment}</>;
  }

  return (
    <>
      {!!shipperOrder?.time_from && shipperOrder?.time_to && (
        <span className="shipper-order-times">
          {moment(shipperOrder?.time_from).tz(shipperOrder?.timezone).format('HH:mm')} -{' '}
          {moment(shipperOrder?.time_to).tz(shipperOrder?.timezone).format('HH:mm')}
        </span>
      )}
      {hasAppointmentTime && <> - {t.appointment}</>}
    </>
  );
};

const ShipperOrderInfo = ({ shipperOrder, isStore }) => {
  const hasContact = !!shipperOrder?.contact_name || shipperOrder?.contact_phone;

  const hasInternalReference = !!shipperOrder?.internal_references?.filter(
    (internalReference) => !!internalReference
  ).length;
  const internalReferencesJoined = joinArrayStringBreakLine(shipperOrder?.internal_references).map(
    (internalReference, key) => <div key={key}>{internalReference}</div>
  );

  const hasSpecialInstructions = !!shipperOrder?.comments?.filter((comment) => !!comment).length;

  const specialInstructionsJoined = joinArrayStringBreakLine(shipperOrder?.comments).map(
    (comment, key) => <div key={key}>{comment}</div>
  );

  return (
    <div className="shipper-order-info" data-testid="shipper-order-info">
      {!isStore && (
        <div className="info-parent">
          <span className="info-title">{t.requested_by_shipper}</span>&nbsp;
          <span>
            <ShipperOrderTimes shipperOrder={shipperOrder} />
          </span>
        </div>
      )}
      {!isStore && shipperOrder?.appointment_required && !!shipperOrder?.appointment_instructions && (
        <div className="info-parent">
          <span className="info-title">{t.appointment_instructions}</span>
          <div>{shipperOrder?.appointment_instructions}</div>
        </div>
      )}
      {hasInternalReference && !isStore && (
        <div className="info-parent">
          <div className="info-title">{t.internal_reference}</div>
          <div>{internalReferencesJoined}</div>
        </div>
      )}
      {hasInternalReference && isStore && (
        <div className="info-parent no-margin">
          <div className="info-title">{t.internal_reference}</div>
          <div>{internalReferencesJoined}</div>
        </div>
      )}
      {!hasInternalReference && isStore && (
        <div className="info-parent no-margin">
          <span className="info-title">{t.no_internal_reference}</span>
        </div>
      )}
      {!isStore && hasSpecialInstructions && (
        <div className="info-parent">
          <div className="info-title">{t.special_instructions}</div>
          <div>{specialInstructionsJoined}</div>
        </div>
      )}
      {!isStore && hasContact && (
        <div className="info-parent no-margin">
          <span className="info-title">{t.contact}</span>{' '}
          <span>
            {shipperOrder?.contact_name}{' '}
            {<Link href={tel(shipperOrder?.contact_phone)} text={shipperOrder?.contact_phone} />}
          </span>
        </div>
      )}
    </div>
  );
};

export default ShipperOrderInfo;
